export const en = {
    no_hotels_found: 'No hotels found, try changing your filters',
};
